// extracted by mini-css-extract-plugin
module.exports = {"category_container":"categories_category_container__1Ad3P","category_section":"categories_category_section__32Plu"};